import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "../../css/ShowRoom.css";

const InteriorDesignNavigation = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    centerMode: true,
    focusOnSelect: true,

    beforeChange: (current, next) => {
      setPrevIndex(current);
      setCurrentIndex(next);
    },

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const slides = [
    {
      id: 1,
      title: "LANCASTER",
      description: "A modern architectural design",
      image: "../Images/landingpageimage/image4.jpg",
    },
    {
      id: 2,
      title: "TEXTYEAH",
      description: "Sleek and minimalistic interiors",
      image: "../Images/landingpageimage/image8.jpg",
    },
    {
      id: 3,
      title: "HIGHVIEW",
      description: "Innovative use of space",
      image: "../Images/landingpageimage/image7.jpg",
    },
    {
      id: 4,
      title: "PORTLANDS",
      description: "Luxury living spaces",
      image: "../Images/landingpageimage/image13.jpg",
    },
  ];

  // Handle the smooth transition timing for description
  useEffect(() => {
    if (prevIndex !== null) {
      const timeout = setTimeout(() => {
        setPrevIndex(null); // Reset the previous index after transition
      }, 800); // Matches the transition duration in CSS (0.8s)
      return () => clearTimeout(timeout);
    }
  }, [prevIndex]);

  return (
    <div className="slider-container">
      
    </div>
  );
};

export default InteriorDesignNavigation;
